import { SettingUserEntity } from '../../../../../core';
import { UserExternalDTO } from '../../../../../core/models/configuration-system/user-external.model';

export const TYPE_USER_EXTERNAL_SETTING = {
  CANCEL: 'TYPE_USER_EXTERNAL_SETTING',
  DELETE: 'TYPE_USER_EXTERNAL_DELETE',
  LOGOUT: 'TYPE_USER_EXTERNAL_LOGOUT'
};

export const userSetting: any = {
  searchText: 'Buscar usuario a partir de 3 dígitos',
  searchTextService: true,
  addText: 'Agregar usuario',
  iconsOfActions: [],
  show: 'No se encontró datos a mostrar',
  paginator: true,
  columns: [
    {
      title: 'Usuario',
      name: 'username',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: SettingUserEntity) => element.username
    },
    {
      title: 'Nombres y apellidos',
      name: 'lastName',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: SettingUserEntity) => {
        return `${element.name} ${element.lastName}`;
      }
    },
    {
      title: 'Entidad(s)',
      name: 'entity',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: SettingUserEntity) => {
        return element.entities.map(item => item.entityName).join(', ');
      }
    },
    {
      title: 'Rol',
      name: 'roles',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: SettingUserEntity) => {
        return element.roles.map(item => item.roleName).join(', ');
      }
    },
    {
      title: 'Permisos Activados',
      name: 'permissions',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: SettingUserEntity) => {
        return element.permissions.join(', ');
      }
    },
    {
      title: 'Estado',
      name: 'blocked',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: SettingUserEntity) => {
        return element.blocked ? 'Inactivo' : 'Activo';
      }
    }
  ]
};


export const userExternalSetting: any = {
  addText: 'Agregar usuario',
  iconsOfActions: [
    { icon: 'cancel', tooltip: 'Cancelar', type: TYPE_USER_EXTERNAL_SETTING.CANCEL },
    { icon: 'deactivate-user', tooltip: 'Desactivar usuario', type: TYPE_USER_EXTERNAL_SETTING.DELETE },
    { icon: 'logout', tooltip: 'Cerrar sesion', type: TYPE_USER_EXTERNAL_SETTING.LOGOUT }

  ],
  show: 'No se encontró datos a mostrar',
  paginator: true,
  columns: [
    {
      title: 'Usuario',
      name: 'username',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: UserExternalDTO) => element.username
    },
    {
      title: 'Nombres y apellidos',
      name: 'lastName',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: UserExternalDTO) => {
        return `${element.name} ${element.lastName}`;
      }
    },
    {
      title: 'Número documento',
      name: 'documentNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: UserExternalDTO) => {
        return element.documentNumber;
      }
    },
    {
      title: 'Entidad(s)',
      name: 'entity',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: UserExternalDTO) => {
        return element.entities.map(item => item.entityName).join(', ');
      }
    },
    {
      title: 'Estado',
      name: 'blocked',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: UserExternalDTO) => {
        return !element.active && element.blocked ? 'Inactivo' : 'Activo';
      }
    },
    {
      title: 'Estado de sesión',
      name: 'activeSession',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: UserExternalDTO) => {
        return element.activeSession == null || element.activeSession == undefined  ? 'N/A' : element.activeSession ? 'Iniciada' : 'Cerrada';
      }
    }
  ]
};
